import { BadgeView } from "../../components/BadgeView";
import { ACHIEVEMENT_STATUS } from "../../utils/constant";
import { AchievementUnlockedMetadata } from "../badgeNotificationKey";

type BadgeEarnedViewProps = {
    title: string;
    description: string;
    metadata: AchievementUnlockedMetadata;
};

export function BadgeEarnedView({ title, description, metadata }: BadgeEarnedViewProps) {
    return (
        <div className="relative flex flex-col gap-6 items-center justify-center">
            <BadgeView
                title={metadata.name || title}
                data={{
                    badge_icon_url: metadata.iconUrl,
                    status: ACHIEVEMENT_STATUS.EARNED,
                    pct_complete: 100,
                }}
            />
            <div className="flex flex-col gap-1 items-center mt-12">
                <span className="text-lg font-semibold leading-[27px] text-black">{title}</span>
                <span className="text-sm text-black">{description}</span>
            </div>
        </div>
    );
}
